export default "__VITE_ASSET__IlGbwo94__"